(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodFilterBar', sodFilterBar);

    function sodFilterBar() {
        return {
            restrict: 'E',
            scope: { config: '=' },
            templateUrl: 'common/components/sod-filter-bar',
            controller: sodFilterBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodFilterBarCtrl($scope, GroupFilterFactory, lodash, FilterFactory) {
            var vm = this;

            this.$onInit = function() {
                // init functions
                vm.handleApply = handleApply;
                vm.handleClear = handleClear;
                vm.handleCancel = handleCancel;
                vm.showAllFilters = showAllFilters;
                vm.hideAllFilters = hideAllFilters;
                vm.setFilters = setFilters;
                vm.filtersCount = 0;

                vm.groupFilterFactory = GroupFilterFactory(lodash.get(vm, 'config.grid_id', null));

                init();
            }



            function handleApply() {
                applyFilter();
                hideAllFilters();
            }

            function handleClear() {
                FilterFactory.set(lodash.get(vm, 'config.grid_id', null), {});
                applyFilter();
                hideAllFilters();
            }

            function handleCancel() {
                hideAllFilters();
            }

            function showAllFilters() {
                vm.isShowingAllFilters = true;
            }

            function hideAllFilters() {
                vm.isShowingAllFilters = false;
            }

            function applyFilter() {
                vm.groupFilterFactory.applyFilter(lodash.get(vm, 'config.grid_id', null));
            }

            function setFilters() {
                vm.filters = FilterFactory.get(lodash.get(vm, 'config.grid_id', null), {});
            }

            function getFilters() {
                return vm.filters;
            }

            function handleFilterCount() {
                var filters = getFilters();
                vm.filtersCount = lodash.reduce(filters, function (accum, filter) {
                    var innerFilterCount = lodash.isArray(filter) ? filter.length : 0;
                    return accum + innerFilterCount;
                }, 0);
            }

            function init() {
                vm.filters = {};
                var filterListener = $scope.$on(
                    [FilterFactory.eventPrefix, lodash.get(vm, 'config.grid_id', null)].join('.'),
                    function (e) {
                        setFilters();
                        handleFilterCount();
                    }
                );

                $scope.$on('$destroy', function () {
                    filterListener();
                });
            }
        }
    }
})();